import { type HolidayIncrement } from "./types";

/**
 * Holiday differential type constants
 */
export const HOLIDAY_DIFFERENTIAL = {
  FLAT: "FLAT" as HolidayIncrement,
  CHARGE_RATE_MULTIPLIER: "CHARGE_RATE_MULTIPLIER" as HolidayIncrement,
};

/**
 * Options for the holiday fee type dropdown
 */
export const HOLIDAY_FEE_TYPE_OPTIONS = [
  { value: HOLIDAY_DIFFERENTIAL.FLAT, label: "Flat Increase" },
  { value: HOLIDAY_DIFFERENTIAL.CHARGE_RATE_MULTIPLIER, label: "Multiplier" },
];
